import { render, staticRenderFns } from "./diseaseTypeNewPop.vue?vue&type=template&id=eddc41d4"
import script from "./diseaseTypeNewPop.vue?vue&type=script&lang=js"
export * from "./diseaseTypeNewPop.vue?vue&type=script&lang=js"
import style0 from "./diseaseTypeNewPop.vue?vue&type=style&index=0&id=eddc41d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports